import { contentTypeId, variantId, layoutId } from '../../../utils/contentful'
import { toSnakeCase } from '../../../utils/string'
import { MODULE_VARIANT_SEPARATOR, MODULE_ID_SEPARATOR } from '../../../utils/sibling-spacing'

export const constructModIds = (idParts = []) => {
  const [module, variant, layout] = idParts
  return [
    module,
    variant || layout ? [module, variant || layout].join(MODULE_VARIANT_SEPARATOR) : undefined,
  ].filter(Boolean)
}

export const constructSiblingSpacingLookupMap = (A = [], B = []) =>
  B.filter(Boolean)
    .reverse()
    .reduce((acc, b) => {
      A.filter(Boolean)
        .reverse()
        .map((a) => {
          acc.push(`${a}${MODULE_ID_SEPARATOR}${b}`)
          return a
        })
      return acc
    }, [])

const getVariant = (entity) => variantId(entity) ?? entity?.variants

export const extractModIdParts = (entity) => [
  contentTypeId(entity),
  getVariant(entity) ? toSnakeCase(getVariant(entity)) : undefined,
  typeof layoutId(entity) === 'string' ? toSnakeCase(layoutId(entity)) : undefined,
]
